window.addEventListener('load', function() {
    if(this.document.querySelector('.start_calendar')){
        var second = 1000, minute = second * 60, hour = minute * 60, date = hour * 24;
        let endYear = document.querySelector('.event_year').dataset.value;
        let endMonth = document.querySelector('.event_month').dataset.value;
        let endDate = document.querySelector('.event_date').dataset.value;
        let endHour = document.querySelector('.event-end-hour').dataset.value;
        let hoursPerDay = 24;
        let minusPerHour = 60;
        let secPerMin = 60;

        let startYear = document.querySelector('.event_year').dataset.startValue;
        let startMonth = document.querySelector('.event_month').dataset.startValue;
        let startDate = document.querySelector('.event_date').dataset.startValue;
        let startHour = document.querySelector('.event-end-hour').dataset.startValue;
        let countDown = new Date(endYear, endMonth, endDate, endHour).getTime();
        let startDown = new Date(startYear, startMonth, startDate, startHour).getTime();
        // Define your PST date components
        let x = this.setInterval(function(){
            const currentDate = new Date();
            const formattedDate = currentDate.toLocaleString("en-US", { timeZone: "PST" });
            const nowtime = new Date(formattedDate).getTime();
            let startTimer = startDown - nowtime;
            if(startTimer < 0){
                document.querySelector('.custom-timer-wrapper').classList.remove('hidden');
                var distance = countDown - nowtime;
                if(distance > 0){
                    Math.floor(distance/(date));
                    let hours = Math.floor((distance) / (hour));
                    let mins = Math.floor((distance % (hour)) / (minute));
                    let sec = Math.floor((distance % (minute)) / (second));
                    if(hours > hoursPerDay){
                        hours = hoursPerDay;
                        mins = minusPerHour;
                        sec = secPerMin;
                    }
                    document.querySelectorAll('.hc_cd_timernum').forEach(item => {
                        item.classList.remove('hidden');
                    })
                    document.querySelectorAll('.timer_loading').forEach(item => {
                        item.classList.add('hidden');
                    })
                    document.querySelectorAll('.js-timer-hours').forEach(hourItem=>{
                        hourItem.innerText = hours;
                    })
                    document.querySelectorAll('.js-timer-minutes').forEach(minuteItem=>{
                        minuteItem.innerText = Math.floor((distance % (hour)) / (minute));
                    })
                    document.querySelectorAll('.js-timer-seconds').forEach(secondItem=>{
                        secondItem.innerText = Math.floor((distance % (minute)) / (second));
                    })
                }else{
                    document.querySelector('.custom-timer-wrapper').classList.add('hidden');
                    clearInterval(x);
                }
            }
        }, second)
    }
})